import { render, staticRenderFns } from "./SegmentSelect.vue?vue&type=template&id=0a53ad4f&"
import script from "./SegmentSelect.vue?vue&type=script&lang=js&"
export * from "./SegmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports